import type { ConductTransformed } from "~pages/Conducts/types/conductTransformed.ts";
import type { ConductResources, ConductResponse } from "~types/conduct.ts";

export const transformConductResponse = (response: ConductResponse): ConductTransformed[] => {
  const resources: ConductResources | undefined = response?.includes?.resources;

  return (response?.data || []).map(
    (conduct) =>
      ({
        ...conduct,
        person: resources?.[conduct?.person?.resourceType ?? ""]?.[conduct?.person?.id ?? ""],
        competition: resources?.[conduct?.competition?.resourceType ?? ""]?.[conduct?.competition?.id ?? ""],
        season: resources?.[conduct?.season?.resourceType ?? ""]?.[conduct?.season?.id ?? ""],
        fixture: resources?.[conduct?.fixture?.resourceType ?? ""]?.[conduct?.fixture?.id ?? ""],
        resources: resources,
      }) as ConductTransformed,
  );
};
